import React from "react";
import { FadeComponent } from "../fadediv/FadeComponent";

export const AdjSQ = ({ show = true }) => {
  return (
    <FadeComponent show={show}>
      <>
        <div className="container stats-explained">
          <h2 style={{ marginBottom: "50px" }}>adjSQ</h2>
          <div className="gray-background-container" style={{ marginBottom: "50px" }}>
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              adjSQ
            </h5>
            <p className="text-template">There are two types of adjSQ:</p>

            <p className="text-template">
              <span
                style={{
                  color: "#F26B0B",
                  fontWeight: 700,
                  fontSize: "16px",
                  marginBottom: "14px",
                }}
              >
                adjOFF SQ
              </span>{" "}
              = adjusted Offensive Shot Quality
            </p>
            <p className="text-template">
              <span style={{ color: "#F26B0B", fontWeight: 700, fontSize: "16px" }}>adjDEF SQ</span> = adjusted
              Defensive Shot Quality
            </p>
            <p className="text-template">
              Both of these stats represent each team's Shot Quality, but adjusting for strength of schedule. So, a team
              in one of the weaker conferences that played lots of bad defenses would have their Offensive Shot Quality
              regressed. Conversely, a team that played lots of good offenses would have their Defensive Shot Quality
              inflated.
            </p>
            <p className="bold-text">
              If you would like to see each team's non-adjusted stats, go to each team's page!
            </p>
          </div>
        </div>
        <div className="container stats-explained" style={{ marginBottom: "150px" }}>
          <div className="text-left">
            <h5 className="sq-points-tittle" style={{ marginBottom: "30px" }}>
              adjSQ Ratings Table
            </h5>
            <div className="row">
              <div className="box col-sm-6">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">Rating</th>
                        <th className="w-50">
                          adjOFF SQ
                          <div className="tooltipCon">
                            <b className="d-block">adjusted Offensive Shot Quality</b>
                            Offensive SQpoints divided by possessions, but adjusting for strength of schedule for each
                            team
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>1.20 or more</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>1.15</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>1.10</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>1.05</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>0.95</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>0.9 or less</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="box col-sm-6">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="w-50">Rating</th>
                        <th className="w-50">
                          adjDEF SQ
                          <div className="tooltipCon">
                            <b className="d-block">adjusted Defensive Shot Quality</b>
                            Defensive SQpoints divided by possessions, but adjusting for strength of schedule for each
                            team.
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Excellent</td>
                        <td>0.9 or less</td>
                      </tr>
                      <tr>
                        <td>Great</td>
                        <td>0.95</td>
                      </tr>
                      <tr>
                        <td>Above Average</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>1.05</td>
                      </tr>
                      <tr>
                        <td>Below Average</td>
                        <td>1.10</td>
                      </tr>
                      <tr>
                        <td>Poor</td>
                        <td>1.15</td>
                      </tr>
                      <tr>
                        <td>Awful</td>
                        <td>1.20 or more</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </FadeComponent>
  );
};
